"use client";
import classNames from "classnames";
import { useState } from "react";

import Multimedia from "@stadium/shared/src/components/shared/multimedia";

import { getUserInitials } from "@stadium/helpers/user";
import useStadiumSharedGlobalConfigContext from "@stadium/shared/src/hooks/use-global-context";
import { useFlags } from "@stadium/services/launch-darkly";

import { SNACKMAGIC, SUPERIORDISHES, SWAGMAGIC } from "@stadium/shared/src/constants/brands";
import { workspaceSidebarFlag } from "@stadium/services/launch-darkly/constants";
import { MY_WORKSPACE_SLUG } from "@stadium/constants";

import defaultStyles from "./main.module.scss";

const AVATAR_COLOR = {
  [SNACKMAGIC]: defaultStyles.snackmagicAvatar,
  [SUPERIORDISHES]: defaultStyles.superiorDishesAvatar,
  [SWAGMAGIC]: defaultStyles.swagmagicAvatar,
};

const emptyObj = {};

const Avatar = ({ user, className = "", styles = defaultStyles, workspace, showAvatarInResponsive = false }) => {
  const { [workspaceSidebarFlag]: workspaceSidebarFlagEnabled } = useFlags();

  const [errorOnLoadingImage, setErrorOnLoadingImage] = useState(false);

  const { site } = useStadiumSharedGlobalConfigContext();
  const avatarStyle = AVATAR_COLOR[site] || styles.defaultAvatar;
  const { firstName, lastName, email, avatarUrl } = user;
  const userDataAvailable = firstName || lastName || email || avatarUrl;

  const { iconUrl, name: workspaceName, slug: workspaceSlug } = workspace || emptyObj;

  const isPersonalWorkspace = workspaceSlug === MY_WORKSPACE_SLUG;

  const getAvatarContent = () => {
    if (avatarUrl && !errorOnLoadingImage) {
      return (
        <div
          className={classNames(
            {
              [styles.avatarContainer]: !workspaceSidebarFlagEnabled,
              [styles.avatarContainerWithLogo]: workspaceSidebarFlagEnabled,
              [styles.responsiveContainer]: showAvatarInResponsive,
            },
            styles.avatar,
            className,
          )}
        >
          <Multimedia
            type="image"
            src={avatarUrl}
            alt={`${firstName} ${lastName}`}
            className={styles.avatarUrl}
            isNextImage={false}
            onError={() => setErrorOnLoadingImage(true)}
          />
          {!isPersonalWorkspace && workspaceSidebarFlagEnabled && iconUrl && (
            <Multimedia
              type="image"
              src={iconUrl}
              alt={workspaceName}
              className={styles.companyLogo}
              isNextImage={false}
            />
          )}
        </div>
      );
    }
    const userInitials = getUserInitials({ ...user });
    return (
      <div
        className={classNames(
          {
            [styles.avatarContainer]: !workspaceSidebarFlagEnabled,
            [styles.avatarContainerWithLogo]: workspaceSidebarFlagEnabled,
            [styles.responsiveContainer]: showAvatarInResponsive,
          },
          avatarStyle,
          styles.userDp,
          className,
        )}
      >
        {userInitials}
        {!isPersonalWorkspace && workspaceSidebarFlagEnabled && iconUrl && (
          <Multimedia
            type="image"
            src={iconUrl}
            alt={workspaceName}
            className={styles.companyLogo}
            isNextImage={false}
          />
        )}
      </div>
    );
  };
  return userDataAvailable ? getAvatarContent() : <></>;
};

export default Avatar;
